<template>
<div class="chapter">
<div class="inner_page">
<div class="story" id="CreatingMissionalCulture-3.html" xml:lang="en-US" xmlns:xml="http://www.w3.org/XML/1998/namespace">
<h2 class="Title" id="heading_id_2">Part One</h2>
<p class="part-title-2" xml:lang="fr-FR">The Power of Culture</p>
<p class="Body"></p>
<p class="Body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?0b443e3b